import { Col, Row } from "antd";

type DefaultLegendProps = {
  first: string;
  second: string;
};

export const DefaultLegend = ({ first, second }: DefaultLegendProps) => {
  return (
    <Row className="mt-4 justify-center">
      <Col className="d-flex align-center mr-4">
        <div className="mr-1 legend all" />
        <p className="my-0 text-sm title mr-6">{first}</p>
      </Col>
      <Col className="d-flex align-center ml-4">
        <div className="mr-1 legend" />
        <p className="text-sm title my-0">{second}</p>
      </Col>
    </Row>
  );
};
